export default __webpack_public_path__ + "static/media/Subtract.61bb817e.svg";